/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [post-text.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 16:54
 */

import React, {useState} from 'react';
import {EmojiText2} from "../emoji/emoji-text";
import NavigationMoreLess from '../navigation-headlines/navigation-more-less';
import {useLanguage} from "../configuration/configuration";

const PostText = ({post, fullview=false}) => {
    const [open, setOpen] = useState(false);
    const Lang = useLanguage();

    const isFullview = (text) => {
        const regex = /<div.*[class|className]\s*=.*fullview.*?>/ig;
        return fullview ? true : regex.test(text);
    }

    const breakText = (text, num) => {
        return text.split(" ").splice(0, num).join(" ");
    }

    const handleOnClick = (event) => {
        event.preventDefault();
        setOpen(!open);
    }

    const {text = ''} = post;
    const isOverflow = !isFullview(text) && text.length > 2056;
    const content = isOverflow && !open ? breakText(text, 80) : text;
    const isShared = post.state === 'SHARED';

    return <div className="post-text">
        {isShared && post.comment && <div>
            <div>{post.comment}</div>
            <hr className='my-2 mx-0'/>
        </div>}
        <EmojiText2 text={content}/>
        {isOverflow &&
            <NavigationMoreLess open={open} onClick={handleOnClick}/>}
    </div>
}

export default PostText;